import { TagAction } from "../../types/TagAction.types";
import { phoneNumbers } from "shared";
import { Dialog } from "../Dialog";
import { Link } from "../Link";

type RoadsideHelpDialogProps = {
  onDismiss: () => void;
  roadsidePhoneTagAction: TagAction;
};

export const RoadsideHelpDialog = ({
  onDismiss,
  roadsidePhoneTagAction,
}: RoadsideHelpDialogProps) => (
  <Dialog title="Roadside Help" size="medium" onDismiss={onDismiss}>
    <p>
      Call{" "}
      <Link
        tagAction={roadsidePhoneTagAction}
        phoneNumber={phoneNumbers.roadside}
      />{" "}
      for roadside assistance.
    </p>
  </Dialog>
);
